import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import api from 'dashboard/resources/top-vlt-games.api';
import { isChainHeadSelector } from 'selectors';

import template from './top-vlt-games-widget.html';

const mapStateToThis = ({ session }) => {
  const isChainHead = isChainHeadSelector({ session });
  const { retailer } = session;

  return {
    retailer,
    isChainHead,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class TopVltGamesWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchTopVltGames(retailerId));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class TopVltGamesWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&',
    };
    this.template = template;
    this.controller = TopVltGamesWidgetController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/top-vlt-games/top-vlt-games-widget-component.js